module.exports = __webpack_public_path__ + "img/Innovation-2022.b9b71b79.png";